
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';

@Component
export default class CloseTaskDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;

  dialog = false
  loading = false

  @Watch('value')
  onValueChange(val: boolean) {
    console.log('CloseTaskDialog: onValueChange()'); // eslint-disable-line no-console

    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  async onNo() {
    console.log('CloseTaskDialog: onNo()'); // eslint-disable-line no-console

    this.dialog = false;

    this.$emit('no');
  }

  async onYes() {
    console.log('CloseTaskDialog: onYes()'); // eslint-disable-line no-console

    this.dialog = false;

    this.$emit('yes');
  }
}
